import Recorder from './recorder';
export class WebAudioApiWavRecorder {
    constructor() {
        this.is_recording = false;
        this.freq_data = new Uint8Array(32);
        let ext_class = this; //Accrocchio che funziona
        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
            .then(function (stream) {
            console.log(AudioContext);
            ext_class.audiocontext = new AudioContext(); //Diventerà offlineaudiocontext
            ext_class.microphone_node = ext_class.audiocontext.createMediaStreamSource(stream);
            ext_class.analyzer_node = ext_class.audiocontext.createAnalyser();
            ext_class.analyzer_node.fftSize = 32;
            ext_class.microphone_node.connect(ext_class.analyzer_node);
            // ext_class.microphone_node.connect(ext_class.audiocontext.destination);
            ext_class.recorder = new Recorder(ext_class.microphone_node, {
                bufferLen: 4096,
                numChannels: 2,
                mimeType: 'audio/wav',
                callback: null
            });
        })
            //.then()
            .catch(function (err) {
            /* handle the error */
        });
    }
    start() {
        this.recorder.clear();
        this.recorder.record();
    }
    stop() {
        this.recorder.stop();
    }
    wav() {
        this.recorder.stop();
        let ext = this;
        let p = new Promise(resolve => {
            ext.recorder.exportWAV(bl => resolve(bl));
        });
        return p;
    }
    time_data() {
        this.analyzer_node.getByteFrequencyData(this.freq_data);
        this.freq_data.map(d => { return d - 125; });
        this.freq_data = this.freq_data;
        return this.freq_data;
    }
}
